<app-default-progress-bar *ngIf="contactList == null"></app-default-progress-bar>

<table
	[dataSource]="contactsDataTable"
	[ngClass]="{ 'mat-elevation-z8': !isCarrierProfile }"
	[ngStyle]="{ border: isCarrierProfile ? '1px solid #ccc' : 'none' }"
	class=""
	mat-table
	matSort
	style="width: 100%"
>
	<ng-container matColumnDef="firstName">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">First Name</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ element.firstName?.replace('null', '') }}
		</td>
	</ng-container>

	<ng-container matColumnDef="lastName">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Last Name</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ element.lastName?.replace('null', '') }}
		</td>
	</ng-container>

	<ng-container matColumnDef="email">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Email</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<a href="mailto:{{ element.email }}">{{ element.email || '' | lowercase }}</a>
		</td>
	</ng-container>

	<ng-container matColumnDef="phoneNumber">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Phone Number</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span
				*ngIf="
					!utilService.isNullOrUndefined(element.phoneNumber) && element.phoneNumber.length > 0
				"
			>
				<span *ngFor="let phone of element.phoneNumber.split(',')">
					<a href="tel:{{ phone }}">
						{{ phone | mask : '(000) 000-0000' }}
						{{
							phone.split(';')[1] != undefined && phone.split(';')[1] != null
								? ' ext. ' + phone.split(';')[1]
								: ''
						}}
						<br />
					</a>
				</span>
			</span>
		</td>
	</ng-container>

	<ng-container *ngIf="isCarrierProfile" matColumnDef="mobileNumber">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Mobile Number</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<a href="tel:{{ element.mobileNumber }}" *ngIf="element?.mobileNumber?.length">
				{{ element.mobileNumber | mask : '(000) 000-0000' }}
			</a>
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile || editPrimaryContact" matColumnDef="primaryContact">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Primary Contact</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-slide-toggle
				(change)="primaryContactToggled($event.checked, element.contactId)"
				[checked]="element.primaryContact"
				color="primary"
			>
			</mat-slide-toggle>
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile" matColumnDef="isMailReciever">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Is Mail Reciever</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-slide-toggle
				(change)="isMailRecieverToggled($event.checked, element.contactId)"
				[checked]="element.isMailReciever"
				class="example-margin"
				color="primary"
			>
			</mat-slide-toggle>
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile" matColumnDef="createdAt">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Created At</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ element.createdAt | date : 'MM/dd/yyyy' }}
		</td>
	</ng-container>

	<ng-container *ngIf="!isCarrierProfile" matColumnDef="actions">
		<th *matHeaderCellDef mat-header-cell>
			<span class="fs-13 color-black">Actions</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<app-carrier-contact-actions
				(updatedContacts)="contactList = $event; buildDatatableView()"
				[carrierId]="carrierId"
				[carrier]="carrier"
				[contactList]="contactList"
				[contact]="element"
				[oldCarrierId]="oldCarrierId"
			></app-carrier-contact-actions>
		</td>
	</ng-container>

	<ng-container *ngIf="incorrectContactInfoEnabled" matColumnDef="contactFeedback">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black"></span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				(click)="contactFeedback(element)"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
			>
				edit
			</mat-icon>
		</td>
	</ng-container>

	<ng-container *ngIf="isEditContact" matColumnDef="editColumn">
		<th *matHeaderCellDef mat-header-cell>
			<mat-icon
				(click)="openContactDialog(null)"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
			>
				person_add_alt_1
			</mat-icon>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				(click)="openContactDialog(element)"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
			>
				edit
			</mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="reportColumn">
		<th *matHeaderCellDef mat-header-cell></th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				(click)="reportDataAction('contact')"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
			>
				report
			</mat-icon>
		</td>
	</ng-container>

	<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
	<tr
		*matRowDef="let row; columns: displayedColumns"
		[ngClass]="{ 'font-weight-bold': (!hasPrioritizedContact && row.primaryContact) || row.prioritizedContact }"
		mat-row
	></tr>
</table>

<mat-paginator
	*ngIf="totalNumberOfContacts > PAGE_SIZE"
	[length]="totalNumberOfContacts"
	[ngClass]="{ 'mat-elevation-z8': !isCarrierProfile }"
	[pageSizeOptions]="[PAGE_SIZE]"
	showFirstLastButtons
>
</mat-paginator>
